import React from 'react';
import {
    HomeTwoTone,
    SettingTwoTone,
    DownSquareTwoTone,
    DeleteTwoTone,
} from '@ant-design/icons';

const DeleteAccountPolicy = () => {
    const steps = [
        {
            title: 'Open the Fanzpick App',
            description: "Launch the app and ensure you're logged in.",
            icon: <HomeTwoTone style={{ fontSize: '25px', marginRight: '12px' }} />,
        },
        {
            title: 'Go to the "Settings" Page',
            description:
                'Tap the "Settings" option, which is accessible from the bottom home screen tabs.',
            icon: <SettingTwoTone style={{ fontSize: '25px', marginRight: '12px' }} />,
        },
        {
            title: 'Scroll to Find "Delete Account"',
            description:
                'On the Settings page, scroll down until you see the "Delete Account" button.',
            icon: <DownSquareTwoTone style={{ fontSize: '25px', marginRight: '12px' }} />,
        },
        {
            title: 'Tap "Delete Account"',
            description:
                'Tap the button and follow the on-screen instructions to confirm account deletion.',
            icon: <DeleteTwoTone style={{ fontSize: '25px', marginRight: '12px' }} />,
        },
    ];

    return (
        <>
            <h1 style={{ color: '#2d5691',}}>Delete Account Policy</h1>
            <div
                style={{
                    minHeight: 'auto',
                    display: 'flex',
                    justifyContent: 'center',
                    // padding: 'rem 2rem',
                    marginBottom:"130px"
                }}
            >
                <div
                    style={{
                        maxWidth: '700px',
                        width: '100%',
                        borderRadius: '12px',
                    }}
                >
                    <h2
                        style={{
                            color: 'black',
                            marginBottom: '2rem',
                            fontSize: '25px',
                            letterSpacing: '-0.02em',
                        }}
                    >
                        How to Delete Your Account
                    </h2>
                    <p
                        style={{
                            fontSize: '18px',
                            color: '#4a5568',
                            marginBottom: '2rem',
                        }}
                    >
                        To delete your Fanzpick account, follow these steps:
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.8rem', marginBottom: '2rem' }}>
                        {steps.map((step, index) => (
                            <div key={index} style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <div>{step.icon}</div>
                                <div>
                                    <h4 style={{ margin: 0, fontSize: '18px', color: '#1a202c' }}>{step.title}</h4>
                                    <p style={{ margin: '4px 0 0', color: '#555', fontSize: '16px' }}>{step.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div
                        style={{
                            backgroundColor: '#fee2e2',
                            borderLeft: '4px solid #ef4444',
                            padding: '1rem',
                            borderRadius: '10px',
                            color: '#b91c1c',
                            fontSize: '16px',
                        }}
                    >
                        <strong>⚠️ Warning:</strong> Deleting your account is permanent and cannot be undone. All data associated with your account will be lost.
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeleteAccountPolicy;
